
import React from 'react';
import cx from 'classnames';

import Icon from '../../Icon';
import Seperator from './Seperator';
import WaitingStep from './WaitingStep';
import Text from '../../Text';

import '../styles/_step.scss';

export default function Step({
  stepLabel,
  isActive,
  needSeparator,
  stepNumber,
  finished
}) {
  function getIcon() {
    if (finished) return <Icon name="finished" color="purple" size={24} />;
    return isActive ? <Icon className="step--separator__icon" name="shootstagrad" spin color="purple" size={24} /> : <WaitingStep stepNumber={stepNumber} />;
  }

  return (
    <div className="step">
      <div>
        {getIcon()}
        {needSeparator ?
        <Seperator seperatorColor={finished ? 'purple' : 'nevada'} /> :
        <></>}
      </div>
      <Text
        noMargin="top"
        className={cx(
          'step--step-label',
          { 'step--step-label__active': !finished && isActive }
        )}>

        {stepLabel}
        {!finished && isActive ? '...' : ''}
      </Text>
    </div>);

}